import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ zone }) =>
    present(
      repository
        .getGanttCalendarRange(zone)
        .then((range) => ({ zone, range }))
        .catch(() => Promise.reject({ zone })),
    );
}

export type { Interactor };

export { createInteractor };
